export default "__VITE_PUBLIC_ASSET__7cd713df__"